import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CopySinkRegistryService {
    private readonly _copySinkTypes: string[] = [];

    public register(copySinkType: string): void {
        this._copySinkTypes.push(copySinkType);
    }

    public has(copySinkType: string): boolean {
        return this._copySinkTypes.find((e) => e === copySinkType) != null;
    }
}
